<div class="loading-screen-container">
  <ap-loading
    [loadingType]="'circular'"
    [indeterminate]="true"
    [circularWidth]="'64px'"
  >
  </ap-loading>
</div>
